export const MESSAGE_TABLE_COLUMNS_INBOX = [
  {
    name: "players.messages.fromId",
    prop: "fromId.personalInfo.firstName",
  },
  {
    name: "players.messages.to",
    prop: "toId.firstName",
  },
  {
    name: "players.messages.subject",
    prop: "subject",
  },
  {
    name: "players.messages.message",
    prop: "message",
  },
];

export const MESSAGE_TABLE_COLUMNS_SENT = [
  {
    name: "players.messages.fromId",
    prop: "fromId.firstName",
  },
  {
    name: "players.messages.to",
    prop: "toId.personalInfo.firstName",
  },
  {
    name: "players.messages.subject",
    prop: "subject",
  },
  {
    name: "players.messages.message",
    prop: "message",
  },
];

export const MESSAGE_STATE = {
  0: "players.messages.sentTo",
  2: "players.messages.read",
  3: "players.messages.unread",
};

export const MESSAGE_TYPE_TAB = {
  INBOX: "inbox",
  SENT: "sent",
};

export const CHAT_USER_TYPES = {
  COLLABORATOR_AGENT: 'collaboratorAgent',
  ADMIN: 'admin',
  COLLABORATOR_OPERATOR: 'collaboratorOperator',
  AGENT: 'agent',
  USER: 'user',
  PLAYER: 'player',
} as const;

export const CHAT_USER_TYPE_TRANSLATIONS = {
  [CHAT_USER_TYPES.COLLABORATOR_AGENT]: 'players.chats.conversation.collaboratorAgent',
  [CHAT_USER_TYPES.ADMIN]: 'players.chats.conversation.administrator',
  [CHAT_USER_TYPES.COLLABORATOR_OPERATOR]: 'players.chats.conversation.operator',
  [CHAT_USER_TYPES.AGENT]: 'players.chats.conversation.agent',
  [CHAT_USER_TYPES.USER]: 'players.chats.conversation.user',
  [CHAT_USER_TYPES.PLAYER]: 'players.chats.conversation.player',
} as const;

export const CHAT_FALLBACK_TRANSLATIONS = {
  UNKNOWN: 'players.chats.conversation.unknown',
  USER: 'players.chats.conversation.user',
  COLLABORATOR_AGENT: 'players.chats.conversation.collaboratorAgent',
  PLAYER: 'players.chats.conversation.player',
} as const;

export const CHAT_DEFAULT_STATE = {
  isLoading: false,
  isInitialLoad: true,
  isLoadingMore: false,
  currentPage: 1,
  hasMore: true,
} as const;

export const CHAT_LOADING_COMPLETE_STATE = {
  isLoading: false,
  isInitialLoad: false,
  isLoadingMore: false,
} as const;

export const CHAT_DATE_LOCALE = 'es-ES';

export const CHAT_TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
};

export const CHAT_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

export const CONVERSATION_USERS = {
  PLAYER: 'Player',
  USER: 'User',
  AGENT: 'agent',
}